// Single source of truth for the whole dashboard. One data load, one
// timeframe — every tab consumes this so the dashboard moves as one.
import React, { createContext, useContext, useEffect, useState,
  useCallback } from "react";
import { loadAll, derive } from "./data.js";

const Ctx = createContext(null);
export const useData = () => useContext(Ctx);

export function tail(arr, months) {
  if (!months || months <= 0) return arr;
  return arr.slice(-months);
}

export function DataProvider({ children }) {
  const [state, setState] = useState({ status: "loading" });
  const period = 0;
  const setPeriod = () => {};

  const refresh = useCallback(() => {
    setState((s) => ({ ...s, status: s.d ? "refreshing" : "loading" }));
    loadAll()
      .then((d) => setState({ status: "ok", d, m: derive(d),
        loadedAt: new Date() }))
      .catch((e) => setState({ status: "error", error: String(e) }));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <Ctx.Provider value={{ ...state, period, setPeriod, refresh }}>
      {children}
    </Ctx.Provider>
  );
}
